import { colors } from 'fitify-ui'
import { Text } from 'fitify-ui-landing/src/components/Text'
import Image from 'next/legacy/image'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { type SyntheticEvent, useEffect, useState } from 'react'
import QRCode from 'react-qr-code'

import { StyledAppsLink } from '@/components/blocks/Apps/Apps.Styled'
import { appLinksData } from '@/data/app-links'

import {
  StyledPromo,
  StyledPromoApps,
  StyledPromoContent,
  StyledPromoList,
  StyledPromoStep,
  StyledQrContainer,
} from './Promo.Styled'

const NEXT_PUBLIC_FITIFY_APP_BASE_PROMO_URL =
  process.env.NEXT_PUBLIC_FITIFY_APP_BASE_PROMO_URL

const Promo = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const code = router.query.code as string
  const [imageError, setImageError] = useState<SyntheticEvent | null>(null)

  useEffect(() => {
    setImageError(null)
  }, [code])

  return (
    <StyledPromo>
      <Image
        src={
          imageError
            ? 'https://static.gofitify.com/images/promo/default.jpg'
            : `https://static.gofitify.com/images/promo/${code}.jpg`
        }
        alt={'promo'}
        onError={setImageError}
        width={'480'}
        height={'194'}
      />
      <StyledPromoContent>
        <Text as={'h2'} variant={'promo-title'}>
          {t('landing_promo_title')}
        </Text>
        <Text as={'p'} variant={'promo-paragraph'}>
          {t('landing_promo_subtitle')}
        </Text>
        <StyledPromoList>
          <StyledPromoStep>
            <Text
              as={'p'}
              variant={'promo-paragraph'}
              style={{ color: colors.Blue900 }}
            >
              {t('landing_promo_step_install')}
            </Text>
            <StyledPromoApps>
              {appLinksData.map((item, index: number) => {
                return (
                  index !== appLinksData.length - 1 && (
                    <StyledAppsLink
                      key={index}
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={item.image}
                        alt={item.alt}
                        width={item.width}
                        height={item.height}
                      />
                    </StyledAppsLink>
                  )
                )
              })}
            </StyledPromoApps>
          </StyledPromoStep>
          <StyledPromoStep>
            <Text
              as={'p'}
              variant={'promo-paragraph'}
              style={{ color: colors.Blue900 }}
              html={t('landing_promo_step_open', {
                0: `${NEXT_PUBLIC_FITIFY_APP_BASE_PROMO_URL + code}`,
              })}
            />
          </StyledPromoStep>
        </StyledPromoList>

        <StyledQrContainer>
          <QRCode
            style={{ backgroundColor: colors.White, padding: '5px' }}
            size={128}
            value={`${NEXT_PUBLIC_FITIFY_APP_BASE_PROMO_URL + code}`}
            viewBox={`0 0 128 128`}
          />
        </StyledQrContainer>
      </StyledPromoContent>
    </StyledPromo>
  )
}

export default Promo
